import React from "react";

const GoldScript = ({ text = "Susan Grau" }) => (
  <svg
    viewBox="0 0 420 130"
    className="w-full max-w-sm mx-auto mt-1 gold-script-svg"
    role="img"
    aria-label={text}
  >
    <defs>
      <linearGradient id="goldInk" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#D4AF37" />
        <stop offset="45%" stopColor="#F3D068" />
        <stop offset="70%" stopColor="#f9ecc2" />
        <stop offset="100%" stopColor="#D4AF37" />
      </linearGradient>
    </defs>
    <text
      x="210"
      y="86"
      textAnchor="middle"
      className="gold-script-text"
      fill="url(#goldInk)"
      stroke="url(#goldInk)"
    >
      {text}
    </text>
  </svg>
);

export default GoldScript;
